import script from "./formulaDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./formulaDetail.vue?vue&type=script&setup=true&lang=js"

import "./formulaDetail.vue?vue&type=style&index=0&id=cf0977a8&lang=less"

const __exports__ = script;

export default __exports__